






























import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import RentCalculator from '@/components/prescriber/RentCalculator.vue';
import DeptRatioCalculator from '@/components/prescriber/DeptRatioCalculator.vue';
import ProspectDocs from '@/components/prescriber/ProspectDocs.vue';
import Forms from '@/components/Forms.vue';
import {
    getCustomerPrescriber,
    postCustomerPrescriber,
    patchCustomerPrescriber,
} from '@/api/api';
import AutocompleteCountry from '@/components/AutocompleteCountry.vue';
import Customer from '@/models/Customer';
import moment from 'moment';
import MetaDatatable from '@/models/MetaDatatable';
import User from '@/models/User';
import get from 'lodash/get';
import AuthModule from '@/store/AuthModule';
import { customerTypes } from '@/data/customerTypes';
import { civilities, families } from '@/data/civilitiesCustomer';
import router from '@/router';
import formatCustomer from '@/utils/formatCustomer';
import { customerStatus, customerStatusColors } from '@/data/customerStatus';
import taxSystems from '@/data/taxSystems';

let customer: Customer | null = null;

async function getCustomer(customerID: string) {
    try {
        const { data } = await getCustomerPrescriber(+customerID);
        return data;
    } catch (error) {
        console.warn(error, get(error, 'response.data.message'));
        return null;
    }
}

function getCustomerName(value: Customer | null) {
    if (value) {
        return formatCustomer(value);
    }
    return 'Prospect';
}

@Component({
    beforeRouteEnter: async (to, from, next) => {
        const { route } = router.resolve({
            name: 'prospects',
        });
        to.meta.breadcrumb[1].url = route.fullPath;

        customer = await getCustomer(to.params.customerID);

        if (!customer) {
            if (to.name === 'editProspect') {
                Vue.prototype.$vs.notify({
                    color: 'danger',
                    position: 'top-right',
                    title: 'Erreur',
                    text: `Prospect introuvable.`,
                });
                next({ name: 'prospects' });
                return;
            }
            if (to.name === 'createProspect') {
                to.meta.breadcrumb[2].title = `Ajout d'un prospect`;
            }
        } else {
            to.meta.breadcrumb[2].title = getCustomerName(customer);
        }

        next();
    },
    components: {
        Forms,
        RentCalculator,
        DeptRatioCalculator,
        ProspectDocs
    },
})
export default class ProspectForm extends Vue {
    errors: any = {};
    error: string | null = null;
    customer: Customer | null = customer;
    loading: boolean = false;

    geozones: any = [
        { text: 'Abis', value: 0 },
        { text: 'outre-mer', value: 1 },
        { text: 'A', value: 2 },
        { text: 'B1', value: 3 },
        { text: 'B2', value: 4 },
        { text: 'C', value: 5 },
    ];

    countries = {
        "AF": "Afghanistan",
        "ZA": "Afrique du Sud",
        "AL": "Albanie",
        "DZ": "Algérie",
        "+49": "Allemagne",
        "AD": "Andorre",
        "AO": "Angola",
        "AI": "Anguilla",
        "AQ": "Antarctique",
        "AG": "Antigua-et-Barbuda",
        "AN": "Antilles néerlandaises",
        "SA": "Arabie saoudite",
        "AR": "Argentine",
        "AM": "Arménie",
        "AW": "Aruba",
        "AU": "Australie",
        "+43": "Autriche",
        "AZ": "Azerbaïdjan",
        "BS": "Bahamas",
        "BH": "Bahreïn",
        "BD": "Bangladesh",
        "BB": "Barbade",
        "BY": "Bélarus",
        "+32": "Belgique",
        "BZ": "Belize",
        "BJ": "Bénin",
        "BM": "Bermudes",
        "BT": "Bhoutan",
        "BO": "Bolivie",
        "BA": "Bosnie-Herzégovine",
        "BW": "Botswana",
        "BR": "Brésil",
        "BN": "Brunéi Darussalam",
        "BG": "Bulgarie",
        "BF": "Burkina Faso",
        "BI": "Burundi",
        "KH": "Cambodge",
        "CM": "Cameroun",
        "CA": "Canada",
        "CV": "Cap-Vert",
        "EA": "Ceuta et Melilla",
        "CL": "Chili",
        "+86": "Chine",
        "CY": "Chypre",
        "CO": "Colombie",
        "KM": "Comores",
        "CG": "Congo-Brazzaville",
        "KP": "Corée du Nord",
        "+82": "Corée du Sud",
        "CR": "Costa Rica",
        "CI": "Côte d’Ivoire",
        "HR": "Croatie",
        "CU": "Cuba",
        "+45": "Danemark",
        "DG": "Diego Garcia",
        "DJ": "Djibouti",
        "DM": "Dominique",
        "EG": "Égypte",
        "SV": "El Salvador",
        "AE": "Émirats arabes unis",
        "EC": "Équateur",
        "ER": "Érythrée",
        "+34": "Espagne",
        "EE": "Estonie",
        "VA": "État de la Cité du Vatican",
        "FM": "États fédérés de Micronésie",
        "+1": "États-Unis",
        "ET": "Éthiopie",
        "FJ": "Fidji",
        "+358": "Finlande",
        "+33": "France",
        "GA": "Gabon",
        "GM": "Gambie",
        "GE": "Géorgie",
        "GS": "Géorgie du Sud et les îles Sandwich du Sud",
        "GH": "Ghana",
        "GI": "Gibraltar",
        "+30": "Grèce",
        "GD": "Grenade",
        "GL": "Groenland",
        "GP": "Guadeloupe",
        "GU": "Guam",
        "GT": "Guatemala",
        "GG": "Guernesey",
        "GN": "Guinée",
        "GQ": "Guinée équatoriale",
        "GW": "Guinée-Bissau",
        "GY": "Guyana",
        "GF": "Guyane française",
        "HT": "Haïti",
        "HN": "Honduras",
        "HU": "Hongrie",
        "BV": "Île Bouvet",
        "CX": "Île Christmas",
        "CP": "Île Clipperton",
        "AC": "Île de l'Ascension",
        "IM": "Île de Man",
        "NF": "Île Norfolk",
        "AX": "Îles Åland",
        "KY": "Îles Caïmans",
        "IC": "Îles Canaries",
        "CC": "Îles Cocos - Keeling",
        "CK": "Îles Cook",
        "FO": "Îles Féroé",
        "HM": "Îles Heard et MacDonald",
        "FK": "Îles Malouines",
        "MP": "Îles Mariannes du Nord",
        "MH": "Îles Marshall",
        "UM": "Îles Mineures Éloignées des États-Unis",
        "SB": "Îles Salomon",
        "TC": "Îles Turks et Caïques",
        "VG": "Îles Vierges britanniques",
        "VI": "Îles Vierges des États-Unis",
        "+91": "Inde",
        "+62": "Indonésie",
        "IQ": "Irak",
        "IR": "Iran",
        "+353": "Irlande",
        "IS": "Islande",
        "IL": "Israël",
        "+39": "Italie",
        "JM": "Jamaïque",
        "+81": "Japon",
        "JE": "Jersey",
        "JO": "Jordanie",
        "KZ": "Kazakhstan",
        "KE": "Kenya",
        "KG": "Kirghizistan",
        "KI": "Kiribati",
        "KW": "Koweït",
        "LA": "Laos",
        "LS": "Lesotho",
        "LV": "Lettonie",
        "LB": "Liban",
        "LR": "Libéria",
        "LY": "Libye",
        "LI": "Liechtenstein",
        "LT": "Lituanie",
        "LU": "Luxembourg",
        "MK": "Macédoine",
        "MG": "Madagascar",
        "+60": "Malaisie",
        "MW": "Malawi",
        "MV": "Maldives",
        "ML": "Mali",
        "MT": "Malte",
        "MA": "Maroc",
        "MQ": "Martinique",
        "MU": "Maurice",
        "MR": "Mauritanie",
        "YT": "Mayotte",
        "+52": "Mexique",
        "MD": "Moldavie",
        "MC": "Monaco",
        "MN": "Mongolie",
        "ME": "Monténégro",
        "MS": "Montserrat",
        "MZ": "Mozambique",
        "MM": "Myanmar",
        "NA": "Namibie",
        "NR": "Nauru",
        "NP": "Népal",
        "NI": "Nicaragua",
        "NE": "Niger",
        "NG": "Nigéria",
        "NU": "Niue",
        "+47": "Norvège",
        "NC": "Nouvelle-Calédonie",
        "NZ": "Nouvelle-Zélande",
        "OM": "Oman",
        "UG": "Ouganda",
        "UZ": "Ouzbékistan",
        "PK": "Pakistan",
        "PW": "Palaos",
        "PA": "Panama",
        "PG": "Papouasie-Nouvelle-Guinée",
        "PY": "Paraguay",
        "+31": "Pays-Bas",
        "PE": "Pérou",
        "+63": "Philippines",
        "PN": "Pitcairn",
        "+48": "Pologne",
        "PF": "Polynésie française",
        "PR": "Porto Rico",
        "+351": "Portugal",
        "QA": "Qatar",
        "HK": "R.A.S. chinoise de Hong Kong",
        "MO": "R.A.S. chinoise de Macao",
        "QO": "régions éloignées de l’Océanie",
        "CF": "République centrafricaine",
        "CD": "République démocratique du Congo",
        "DO": "République dominicaine",
        "CZ": "République tchèque",
        "RE": "Réunion",
        "RO": "Roumanie",
        "+44": "Royaume-Uni",
        "RU": "Russie",
        "RW": "Rwanda",
        "EH": "Sahara occidental",
        "BL": "Saint-Barthélémy",
        "KN": "Saint-Kitts-et-Nevis",
        "SM": "Saint-Marin",
        "MF": "Saint-Martin",
        "PM": "Saint-Pierre-et-Miquelon",
        "VC": "Saint-Vincent-et-les Grenadines",
        "SH": "Sainte-Hélène",
        "LC": "Sainte-Lucie",
        "WS": "Samoa",
        "AS": "Samoa américaines",
        "ST": "Sao Tomé-et-Principe",
        "SN": "Sénégal",
        "RS": "Serbie",
        "CS": "Serbie-et-Monténégro",
        "SC": "Seychelles",
        "SL": "Sierra Leone",
        "+65": "Singapour",
        "SK": "Slovaquie",
        "SI": "Slovénie",
        "SO": "Somalie",
        "SD": "Soudan",
        "LK": "Sri Lanka",
        "+46": "Suède",
        "+41": "Suisse",
        "SR": "Suriname",
        "SJ": "Svalbard et Île Jan Mayen",
        "SZ": "Swaziland",
        "SY": "Syrie",
        "TJ": "Tadjikistan",
        "TW": "Taïwan",
        "TZ": "Tanzanie",
        "TD": "Tchad",
        "TF": "Terres australes françaises",
        "IO": "Territoire britannique de l'océan Indien",
        "PS": "Territoire palestinien",
        "+66": "Thaïlande",
        "TL": "Timor oriental",
        "TG": "Togo",
        "TK": "Tokelau",
        "TO": "Tonga",
        "TT": "Trinité-et-Tobago",
        "TA": "Tristan da Cunha",
        "TN": "Tunisie",
        "TM": "Turkménistan",
        "TR": "Turquie",
        "TV": "Tuvalu",
        "UA": "Ukraine",
        "EU": "Union européenne",
        "UY": "Uruguay",
        "VU": "Vanuatu",
        "VE": "Venezuela",
        "VN": "Viêt Nam",
        "WF": "Wallis-et-Futuna",
        "YE": "Yémen",
        "ZM": "Zambie",
        "ZW": "Zimbabwe"
    };

    lotSection: string = 'FUTUR PROJET IMMOBILIER';
    revenuesSections: string = 'REVENUS';
    infoSection: string = 'INFORMATIONS GENERALES';
    familySection: string = 'FAMILLE';
    taxSection: string = 'IMPOSITION';
    notarySection: string = 'NOTAIRE DE FAMILLE';
    horizonSection: string = 'OBJECTIFS DU CLIENT';
    financialSection: string = 'PROJET IMMOBILIER';

    get title() {
        if (customer) {
            return formatCustomer(customer);
        }
        return `Ajout d'un prospect`;
    }

    clickButton() {
        // @ts-ignore
        this.$refs.form.submit();
    }

    extractPhoneComponents(phoneValue: string | null): { countryCode: string, phoneNumber: string } {
    if (!phoneValue) return { countryCode: '+33', phoneNumber: '' };
    
    // Détecte le format "(+XX) XXXXXXXXX"
    const indicatifPattern = /^\((\+\d+)\)\s*(.*)$/;
    const match = phoneValue.match(indicatifPattern);
    
    if (match) {
        // Si le format correspond, on extrait l'indicatif et le numéro
        return {
            countryCode: match[1],        // "+XX"
            phoneNumber: match[2].trim()  // "XXXXXXXXX" (sans espaces au début/fin)
        };
    }
    
    // Si pas de correspondance, on retourne le numéro tel quel 
    // et on utilise l'indicatif par défaut '+33'
    return {
        countryCode: '+33',
        phoneNumber: phoneValue
    };
}

formatPhoneNumber(countryCode: string, phoneNumber: string | null): string {
    if (!countryCode || !phoneNumber) return '';
    return `(${countryCode}) ${phoneNumber}`;
}

    get type(): 'edit' | 'add' | 'details' | null {
        switch (this.$route.name) {
            case 'editProspect':
                return 'edit';
            default:
                return 'add';
        }
    }

    get prospectID(): number | null {
        return +this.$route.params.customerID;
    }

    /**
     * Détecte si au moins un champ du deuxième acquéreur est renseigné.
     * Dès qu'un champ du second acquéreur est rempli, on considère
     * que TOUS les champs "2" (sauf ceux explicitement exclus) doivent devenir obligatoires.
     */
    get hasSecondBuyer(): boolean {
        const v = this.values;
        return Boolean(
            v.civility_2 ||
            v.second_firstname ||
            v.second_lastname ||
            v.date_of_birth_2 ||
            v.email_2 ||
            v.mobile_2 ||
            // v.workplace_2 (exclu car non obligatoire)
            (v.address_2 && (
                v.address_2.street ||
                // v.address_2.street2 est non obligatoire
                v.address_2.postal_code ||
                v.address_2.city
            ))
        );
    }

    get items() {
        return [
            {
                label: 'Statut Prospect',
                name: 'status',
                type: 'select',
                items: this.customerStatus,
            },
            {
                name: 'company_name',
                label: 'Si Acquéreur Personne Morale, nom Sté *',
                type: 'text',
                errorMessage: 'Le nom est requis',
                hidden: this.values.civility !== 'Société',
            },
            {
                name: 'civility',
                label: 'Civilité 1er Acquéreur *',
                type: 'select',
                required: true,
                items: this.customerCivilitiesArr,
            },
            {
                name: 'first_firstname',
                label: 'Prénom 1er Acquéreur *',
                type: 'text',
                errorMessage: 'Le prénom est requis',
                hidden: this.values.civility === 'Société',
                required: this.values.civility !== 'Société',
            },
            {
                name: 'first_lastname',
                label: 'Nom 1er Acquéreur *',
                type: 'text',
                errorMessage: 'Le nom est requis',
                hidden: this.values.civility === 'Société',
                required: this.values.civility !== 'Société',
            },
            {
                name: 'birthdate',
                label: 'Date naissance 1er Acquéreur',
                type: 'date',
            },
            {
                name: 'address',
                type: 'address',
                fields: {
                    country: {
                        label: 'Pays *',
                        name: 'country',
                        type: 'autocomplete',
                        component: AutocompleteCountry, 
                        items: Object.entries(this.countries).map(([value, text]) => ({ value, text })),
                        required: true,
                        errorMessage: 'Le pays est requis'
                    },
                    street: {
                        label: 'Adresse 1er Acquéreur',
                        name: 'street',
                        errorMessage: 'L\'adresse est requise'
                    },
                    street2: {
                        label: `Complément d'adresse 1er Acquéreur`,
                        name: 'street2',
                    },
                    postal_code: {
                        label: 'Code postal 1er Acquéreur *',
                        name: 'postal_code',
                        required: true,
                        errorMessage: 'Le code postal est requis'
                    },
                    city: {
                        label: 'Ville 1er Acquéreur *',
                        name: 'city',
                        required: true,
                        errorMessage: 'La ville est requise'
                    },
                },
            },
            {
                name: 'email',
                label: 'Email 1er Acquéreur *',
                type: 'text',
                errorMessage: "L'email est requis",
                required: true,
            },
            {
                name: 'mobile',
                label: 'Mobile 1er Acquéreur',
                type: 'text',
                withCountryCode: true,
                phoneIndicatives: Object.entries(this.countries)
                // on ne garde que les clés qui commencent par "+"
                .filter(([code, label]) => code.startsWith('+'))
                // on transforme en { value: '+33', text: 'France' }
                .map(([code, label]) => ({
                value: code,
                text: label,
                })),
                errorMessage: 'Le numéro de téléphone est requis',
                required: true,
            },
            {
                name: 'workplace',
                label: 'Lieu de travail 1er Acquéreur ',
                type: 'text',
            },

            // ------------------ CHAMPS DU DEUXIÈME ACQUÉREUR -----------------
            {
                name: 'civility_2',
                label: this.hasSecondBuyer
                    ? 'Civilité 2ème Acquéreur *'
                    : 'Civilité 2ème Acquéreur',
                type: 'select',
                items: this.customerCivilitiesArr,
                required: this.hasSecondBuyer,
                errorMessage: 'Le deuxième acquéreur doit être renseigné',
            },
            {
                name: 'second_firstname',
                label: this.hasSecondBuyer
                    ? 'Prénom 2ème Acquéreur *'
                    : 'Prénom 2ème Acquéreur',
                type: 'text',
                errorMessage: 'Le deuxième acquéreur doit être renseigné',
                required: this.hasSecondBuyer,
            },
            {
                name: 'second_lastname',
                label: this.hasSecondBuyer
                    ? 'Nom 2ème Acquéreur *'
                    : 'Nom 2ème Acquéreur',
                type: 'text',
                errorMessage: 'Le deuxième acquéreur doit être renseigné',
                required: this.hasSecondBuyer,
            },
            {
                name: 'date_of_birth_2',
                label: this.hasSecondBuyer
                    ? 'Date naissance 2ème Acquéreur *'
                    : 'Date naissance 2ème Acquéreur',
                type: 'date',
                errorMessage: 'Le deuxième acquéreur doit être renseigné',
                required: this.hasSecondBuyer,
            },
            {
                name: 'address_2',
                type: 'address',
                fields: {
                    street: {
                        label: this.hasSecondBuyer
                            ? 'Adresse 2ème Acquéreur'
                            : 'Adresse 2ème Acquéreur',
                        name: 'street',
                    },
                    street2: {
                        label: `Complément d'adresse 2ème Acquéreur`, // Non obligatoire
                        name: 'street2',
                    },
                    postal_code: {
                        label: 'Code postal 2ème Acquéreur',
                        name: 'postal_code',
                    },
                    city: {
                        label: 'Ville 2ème Acquéreur',
                        name: 'city',
                    },
                },
            },
            {
                name: 'email_2',
                label: this.hasSecondBuyer
                    ? 'Email 2ème Acquéreur *'
                    : 'Email 2ème Acquéreur',
                type: 'text',
                errorMessage: 'Le deuxième acquéreur doit être renseigné',
                required: this.hasSecondBuyer,
            },
            {
                name: 'mobile_2',
                label: this.hasSecondBuyer
                    ? 'Mobile 2ème Acquéreur'
                    : 'Mobile 2ème Acquéreur',
                type: 'text',
                withCountryCode: true,
                phoneIndicatives: Object.entries(this.countries)
                // on ne garde que les clés qui commencent par "+"
                .filter(([code, label]) => code.startsWith('+'))
                // on transforme en { value: '+33', text: 'France' }
                .map(([code, label]) => ({
                value: code,
                text: label,
                })),
                errorMessage: 'Le deuxième acquéreur doit être renseigné',
                required: this.hasSecondBuyer,
            },
            //  ⬇️ Reste toujours facultatif, pas d'astérisque, pas de message d'erreur ⬇️
            {
                name: 'workplace_2',
                label: 'Lieu de travail 2ème Acquéreur',
                type: 'text',
                required: false,
                errorMessage: '',
            },

            // ------------------ FIN DES CHAMPS DU DEUXIÈME ACQUÉREUR -----------------

            {
                name: 'family_situation',
                label: 'Situation familiale *',
                type: 'select',
                items: this.customerFamilyArr,
                section: this.familySection,
            },
            {
                name: 'wedding_date',
                label: 'Date du PACSE/MARIAGE',
                type: 'date',
                section: this.familySection,
            },
            {
                name: 'wedding_place',
                label: 'Lieu du PACSE/MARIAGE',
                type: 'text',
                section: this.familySection,
            },
            {
                name: 'wedding_master',
                label: 'Recu par Maitre/Mairie/Tribunal et mentionner la date',
                type: 'text',
                section: this.familySection,
            },
            {
                name: 'share_of_taxe_home',
                label: 'Nombre de part fiscal',
                type: 'number',
                section: this.familySection,
            },
            {
                name: 'people_in_tax_home',
                label: 'Nombre de personne dans le foyer fiscal',
                type: 'number',
                section: this.familySection,
            },
            {
                name: 'childrens_in_tax_home',
                label: 'Nombre d\'enfants à charge',
                type: 'number',
                section: this.familySection,
            },
            {
                name: 'first_household_reference_income_taxe',
                label: 'RFR Année N-1 1er Acquéreur',
                type: 'number',
                section: this.revenuesSections,
            },
            {
                name: 'second_household_reference_income_taxe',
                label: 'RFR Année N-2 1er Acquéreur',
                type: 'number',
                section: this.revenuesSections,
            },
            {
                name: 'monthly_pay',
                label: 'Revenus net mensuels 1er Acquéreur',
                type: 'number',
                section: this.revenuesSections,
            },
            {
                label: 'Profession 1er Acquéreur',
                name: 'job_status',
                type: 'select',
                items: [
                    { text: 'Salarié', value: 'employee' },
                    { text: 'NC', value: 'nc' },
                ],
                section: this.revenuesSections,
            },
            {
                label: 'Depuis',
                name: 'job_since',
                type: 'number',
                section: this.revenuesSections,
                requires: ['job_status', 'employee'],
            },
            {
                label: 'Frais Réels 1er Acquéreur (€ /an)',
                name: 'real_costs',
                type: 'number',
                section: this.revenuesSections,
            },
            {
                label: 'Loyers Perçus 1er Acquéreur (€ /an Brut)',
                name: 'rent_collected',
                type: 'number',
                section: this.revenuesSections,
            },
            {
                label: 'Dividendes avant abattement 1er Acquéreur (€ /an)',
                name: 'dividends_before_deduction',
                type: 'number',
                section: this.revenuesSections,
            },
            {
                label: 'Autres revenus avant abattement 1er Acquéreur (€ /an Net)',
                name: 'other_income_before_deduction',
                type: 'number',
                section: this.revenuesSections,
            },
            {
                name: 'first_household_reference_income_taxe_2',
                label: 'RFR Année N-1 2ème Acquéreur',
                type: 'number',
                section: this.revenuesSections,
            },
            {
                name: 'second_household_reference_income_taxe_2',
                label: 'RFR Année N-2 2ème Acquéreur',
                type: 'number',
                section: this.revenuesSections,
            },
            {
                name: 'monthly_pay_2',
                label: 'Revenus net mensuels 2eme Acquéreur',
                type: 'number',
                section: this.revenuesSections,
            },
            {
                label: 'Profession 2eme Acquéreur',
                name: 'job_status_2',
                type: 'select',
                items: [
                    { text: 'Salarié', value: 'employee' },
                    { text: 'NC', value: 'nc' },
                ],
                section: this.revenuesSections,
            },
            {
                label: 'Depuis',
                name: 'job_since_2',
                type: 'number',
                section: this.revenuesSections,
                requires: ['job_status_2', 'employee'],
            },
            {
                label: 'Frais Réels 2eme Acquéreur (€ /an)',
                name: 'real_costs_2',
                type: 'number',
                section: this.revenuesSections,
            },
            {
                label: 'Loyers Perçus 2eme Acquéreur (€ /an Brut)',
                name: 'rent_collected_2',
                type: 'number',
                section: this.revenuesSections,
            },
            {
                label: 'Dividendes avant abattement 2eme Acquéreur (€ /an)',
                name: 'dividends_before_deduction_2',
                type: 'number',
                section: this.revenuesSections,
            },
            {
                label: 'Autres revenus avant abattement 2eme Acquéreur (€ /an Net)',
                name: 'other_income_before_deduction_2',
                type: 'number',
                section: this.revenuesSections,
            },
            {
                name: 'tax_residence',
                label: 'Residence Fiscale 1er Acquéreur',
                type: 'text',
                section: this.taxSection,
            },
            {
                name: 'tax_number',
                label: 'Numéro Fiscal NIF 1er Acquéreur',
                type: 'text',
                section: this.taxSection,
            },
            {
                name: 'income_taxe',
                label: 'Montant IR payés (€/an) avant investissement du 1er Acquéreur',
                type: 'number',
                section: this.taxSection,
            },
            {
                name: 'income_deduction',
                label: 'Deduction IR 1er Acquéreur (€ /an)',
                type: 'number',
                section: this.taxSection,
            },
            {
                name: 'income_deduction_reason',
                label: 'Motif deduction IR 1er Acquéreur',
                type: 'text',
                section: this.taxSection,
            },
            {
                name: 'tax_reduction',
                label: 'Réduction IR 1er Acquéreur (€ /an)',
                type: 'number',
                section: this.taxSection,
            },
            {
                name: 'tax_reduction_reason',
                label: 'Motif réduction IR 1er Acquéreur',
                type: 'text',
                section: this.taxSection,
            },
            {
                name: 'csg_crds',
                label: 'CSG / CRDS 1er Acquéreur (€ /an)',
                type: 'number',
                section: this.taxSection,
            },
            {
                name: 'tax_credit',
                label: "Crédit d'impots 1er Acquéreur (€ /an)",
                type: 'number',
                section: this.taxSection,
            },
            {
                name: 'tax_before_reduction',
                label: 'Impots avant reduction 1er Acquéreur (€ /an)',
                type: 'number',
                section: this.taxSection,
            },
            {
                name: 'real_estate_taxes',
                label: 'Impots sur fortune immobilière 1er Acquéreur (€ /an)',
                type: 'number',
                section: this.taxSection,
            },
            {
                name: 'dom_deduction',
                label: 'Abattement DOM 1er Acquéreur (%)',
                type: 'number',
                section: this.taxSection,
            },
            {
                name: 'tax_residence_c2',
                label: 'Residence Fiscale 2eme Acquéreur',
                type: 'text',
                section: this.taxSection,
            },
            {
                name: 'tax_number_c2',
                label: 'Numéro Fiscal NIF 2eme Acquéreur',
                type: 'text',
                section: this.taxSection,
            },
            {
                name: 'income_taxe_2',
                label: 'Montant IR payés (€/an) avant investissement du 2eme Acquéreur',
                type: 'number',
                section: this.taxSection,
            },
            {
                name: 'income_deduction_2',
                label: 'Montant Deduction IR 2eme Acquéreur (€ /an)',
                type: 'number',
                section: this.taxSection,
            },
            {
                name: 'income_deduction_reason_2',
                label: 'Motif deduction IR 2eme Acquéreur',
                type: 'text',
                section: this.taxSection,
            },
            {
                name: 'tax_reduction_2',
                label: 'Montant Réduction IR 2eme Acquéreur (€ /an)',
                type: 'number',
                section: this.taxSection,
            },
            {
                name: 'tax_reduction_reason_2',
                label: 'Motif réduction IR 2eme Acquéreur',
                type: 'text',
                section: this.taxSection,
            },
            {
                name: 'csg_crds_2',
                label: 'CSG / CRDS 2eme Acquéreur (€ /an)',
                type: 'number',
                section: this.taxSection,
            },
            {
                name: 'tax_credit_2',
                label: "Crédit d'impots 2eme Acquéreur (€ /an)",
                type: 'number',
                section: this.taxSection,
            },
            {
                name: 'tax_before_reduction_2',
                label: 'Impots avant reduction 2eme Acquéreur (€ /an)',
                type: 'number',
                section: this.taxSection,
            },
            {
                name: 'real_estate_taxes_2',
                label: 'Impots sur fortune immobilière 2eme Acquéreur (€ /an)',
                type: 'number',
                section: this.taxSection,
            },
            {
                name: 'dom_deduction_2',
                label: 'Abattement DOM 2eme Acquéreur (%)',
                type: 'number',
                section: this.taxSection,
            },
            {
                name: 'max_credit',
                label: "Montant Maximum de l’Emprunt (€)",
                type: 'number',
                section: this.financialSection,
            },
            {
                name: 'max_credit_duration',
                label: 'Durée Maximale prêt(s) en années',
                type: 'number',
                section: this.financialSection,
            },
            {
                name: 'rate_excluding_insurance',
                label: ' Taux hors ass. Maxi en % ',
                type: 'number',
                section: this.financialSection,
            },
            {
                name: 'tax_chosen',
                label: 'Présicer le Dispositif Fiscal choisi (ex: PINEL-RP)',
                type: 'select',
                items: taxSystems,
                section: this.financialSection,
            },
            {
                name: 'other_conditions',
                label: 'Autres conditions suspensives',
                type: 'text',
                section: this.financialSection,
            },
            {
                name: 'investment_horizon',
                label: "Horizon d'investissement",
                type: 'select',
                items: [
                    { text: '6 ans', value: '6' },
                    { text: '9 ans', value: '9' },
                    { text: '12 ans', value: '12' },
                    { text: '+ de 12 ans', value: '12+' },
                ],
                section: this.horizonSection,
            },
            {
                name: 'income_goals',
                label: 'Revenus (€)',
                type: 'number',
                section: this.horizonSection,
            },
            {
                name: 'capital_goals',
                label: 'Capital (€)',
                type: 'number',
                section: this.horizonSection,
            },
            {
                name: 'retirement_goals',
                label: 'Retraite (€)',
                type: 'number',
                section: this.horizonSection,
            },
            {
                label: 'Zone Géofiscale',
                name: 'geo_zone',
                type: 'select',
                items: this.geozones,
                section: this.financialSection,
            },
            {
                label: 'Surface (en m²)',
                name: 'surface',
                type: 'number',
                section: this.financialSection,
            },
            {
                label: 'Loyer (Environ)',
                name: 'rent',
                type: 'number',
                section: this.financialSection,
            },
            {
                label: 'Apport personnel',
                name: 'personnal_apport',
                type: 'number',
                section: this.financialSection,
            },
            {
                label: 'Prix du lot',
                name: 'lot_price',
                type: 'number',
                section: this.financialSection,
            },
            {
                label: "Date d'acquisition",
                name: 'acquisition_date',
                type: 'date',
                section: this.financialSection,
            },
            {
                label: 'Frais de notaire',
                name: 'notary_fees',
                type: 'number',
                section: this.financialSection,
            },
            {
                name: 'study_coordinates',
                label: 'Coordonnées Étude',
                type: 'text',
                section: this.notarySection,
            },
            {
                name: 'study_contact',
                label: 'Contact direct Me ',
                type: 'text',
                section: this.notarySection,
            },
            {
                name: 'study_mobile',
                label: 'Ligne directe',
                type: 'text',
                section: this.notarySection,
            },
            {
                name: 'study_email',
                label: 'Email Notaire/clerc en charge du dossier',
                type: 'text',
                section: this.notarySection,
            },
            {
                name: 'study_address',
                type: 'address',
                fields: {
                    street: {
                        label: 'Adresse',
                        name: 'street',
                    },
                    street2: {
                        label: `Complément d'adresse`,
                        name: 'street2',
                    },
                    postal_code: {
                        label: 'Code postal',
                        name: 'postal_code',
                    },
                    city: {
                        label: 'Ville',
                        name: 'city',
                    },
                },
                section: this.notarySection,
            },
        ];
    }

    defaultValue: any | null = {
        civility: null,
        family_situation: null,
        first_firstname: null,
        first_lastname: null,
        second_firstname: null,
        second_lastname: null,
        company_name: null,
        email: null,
        birthdate: null,
        phone: null,
        mobile: null,
        mobile_code: '+33',
        workplace: null,
        income_taxe: null,
        first_household_reference_income_taxe: null,
        second_household_reference_income_taxe: null,
        share_of_taxe_home: null,
        people_in_tax_home: null,
        childrens_in_tax_home: null,
        monthly_pay: null,
        address: {
            country: 'France',
            street: null,
            street2: null,
            postal_code: null,
            city: null,
        },
        status: null,
        notary_fees: null,
        tax_system: null,
        geo_zone: null,
        acquisition_date: null,
        surface: null,
        rent: null,
        personnal_apport: null,
        credit_rate: null,
        credit_duration: null,
        lot_price: null,

        job_status: null,
        job_since: null,
        real_costs: null,
        rent_collected: null,
        dividends_before_deduction: null,
        other_income_before_deduction: null,
        tax_residence: null,
        tax_residence_c2: null,
        tax_number: null,
        tax_number_c2: null,
        taxes_c2: null,
        tax_before_reduction: null,
        csg_crds: null,
        real_estate_taxes: null,
        dom_deduction: null,
        income_deduction: null,
        income_deduction_reason: null,
        tax_reduction: null,
        tax_reduction_reason: null,
        tax_credit: null,
        investment_horizon: null,
        income_goals: null,
        capital_goals: null,
        retirement_goals: null,

        civility_2: null,
        date_of_birth_2: null,
        address_2: {
            street: null,
            street2: null,
            postal_code: null,
            city: null,
        },
        email_2: null,
        mobile_2: null,
        mobile_2_code: '+33',
        workplace_2: null,
        wedding_date: null,
        wedding_place: null,
        wedding_master: null,
        first_household_reference_income_taxe_2: null,
        second_household_reference_income_taxe_2: null,
        monthly_pay_2: null,
        job_status_2: null,
        job_since_2: null,
        real_costs_2: null,
        rent_collected_2: null,
        dividends_before_deduction_2: null,
        other_income_before_deduction_2: null,
        income_taxe_2: null,
        income_deduction_2: null,
        income_deduction_reason_2: null,
        tax_reduction_2: null,
        tax_reduction_reason_2: null,
        csg_crds_2: null,
        tax_credit_2: null,
        tax_before_reduction_2: null,
        real_estate_taxes_2: null,
        dom_deduction_2: null,
        study_coordinates: null,
        study_contact: null,
        study_mobile: null,
        study_email: null,
        study_address: {
            street: null,
            street2: null,
            postal_code: null,
            city: null,
        },
        max_credit: null,
        max_credit_duration: null,
        rate_excluding_insurance: null,
        tax_chosen: null,
        other_conditions: null,
    };

    values: any = this.defaultValue;

    async created(): Promise<void> {
        this.init();
    }

    async init() {
        this.loading = true;
        if (this.type === 'edit' && this.prospectID && this.customer) {
            this.defaultValue.civility = this.customer.civility || null;
            this.defaultValue.family_situation = this.customer.family_situation || null;
            this.defaultValue.first_firstname = this.customer.first_firstname || null;
            this.defaultValue.first_lastname = this.customer.first_lastname || null;
            this.defaultValue.second_firstname = this.customer.second_firstname || null;
            this.defaultValue.second_lastname = this.customer.second_lastname || null;
            this.defaultValue.company_name = this.customer.company_name || null;
            this.defaultValue.email = this.customer.email || null;
            this.defaultValue.birthdate = this.customer.birthdate && moment(this.customer.birthdate) || null;
            this.defaultValue.phone = this.customer.phone || null;
            if (this.customer.mobile) {
                const { countryCode, phoneNumber } = this.extractPhoneComponents(this.customer.mobile);
                this.defaultValue.mobile = phoneNumber;
                this.defaultValue.mobile_code = countryCode;
            } else {
                this.defaultValue.mobile = null;
                this.defaultValue.mobile_code = '+33';
            }
            this.defaultValue.workplace = this.customer.workplace || null;
            this.defaultValue.income_taxe = this.customer.income_taxe || null;
            this.defaultValue.first_household_reference_income_taxe = this.customer.first_household_reference_income_taxe || null;
            this.defaultValue.second_household_reference_income_taxe = this.customer.second_household_reference_income_taxe || null;
            this.defaultValue.share_of_taxe_home = this.customer.share_of_taxe_home || null;
            this.defaultValue.people_in_tax_home = this.customer.people_in_tax_home || null;
            this.defaultValue.monthly_pay = this.customer.monthly_pay || null;
            this.defaultValue.childrens_in_tax_home = this.customer.childrens_in_tax_home || null;
            this.defaultValue.address.country = (this.customer.address && this.customer.address.country) || null;
            this.defaultValue.address.street = (this.customer.address && this.customer.address.street) || null;
            this.defaultValue.address.street2 = (this.customer.address && this.customer.address.street2) || null;
            this.defaultValue.address.postal_code = (this.customer.address && this.customer.address.postal_code) || null;
            this.defaultValue.address.city = (this.customer.address && this.customer.address.city) || null;
            this.defaultValue.status = this.customer.status || null;
            this.defaultValue.notary_fees = this.customer.notary_fees || null;
            this.defaultValue.tax_system = this.customer.tax_system || null;
            this.defaultValue.geo_zone = this.customer.geo_zone || null;
            this.defaultValue.acquisition_date = this.customer.acquisition_date && moment(this.customer.acquisition_date) || null;
            this.defaultValue.surface = this.customer.surface || null;
            this.defaultValue.rent = this.customer.rent || null;
            this.defaultValue.personnal_apport = this.customer.personnal_apport || null;
            this.defaultValue.credit_rate = this.customer.credit_rate || null;
            this.defaultValue.credit_duration = this.customer.credit_duration || null;
            this.defaultValue.lot_price = this.customer.lot_price || null;

            this.defaultValue.job_status = this.customer.job_status || null;
            this.defaultValue.job_since = this.customer.job_since || null;
            this.defaultValue.real_costs = this.customer.real_costs || null;
            this.defaultValue.rent_collected = this.customer.rent_collected || null;
            this.defaultValue.dividends_before_deduction = this.customer.dividends_before_deduction || null;
            this.defaultValue.other_income_before_deduction = this.customer.other_income_before_deduction || null;
            this.defaultValue.tax_residence = this.customer.tax_residence || null;
            this.defaultValue.tax_residence_c2 = this.customer.tax_residence_c2 || null;
            this.defaultValue.tax_number = this.customer.tax_number || null;
            this.defaultValue.tax_number_c2 = this.customer.tax_number_c2 || null;
            this.defaultValue.taxes_c2 = this.customer.taxes_c2 || null;
            this.defaultValue.tax_before_reduction = this.customer.tax_before_reduction || null;
            this.defaultValue.csg_crds = this.customer.csg_crds || null;
            this.defaultValue.real_estate_taxes = this.customer.real_estate_taxes || null;
            this.defaultValue.dom_deduction = this.customer.dom_deduction || null;
            this.defaultValue.income_deduction = this.customer.income_deduction || null;
            this.defaultValue.income_deduction_reason = this.customer.income_deduction_reason || null;
            this.defaultValue.tax_reduction = this.customer.tax_reduction || null;
            this.defaultValue.tax_reduction_reason = this.customer.tax_reduction_reason || null;
            this.defaultValue.tax_credit = this.customer.tax_credit || null;
            this.defaultValue.investment_horizon = this.customer.investment_horizon || null;
            this.defaultValue.income_goals = this.customer.income_goals || null;
            this.defaultValue.capital_goals = this.customer.capital_goals || null;
            this.defaultValue.retirement_goals = this.customer.retirement_goals || null;

            this.defaultValue.civility_2 = this.customer.civility_2 || null;
            this.defaultValue.date_of_birth_2 = this.customer.date_of_birth_2 && moment(this.customer.date_of_birth_2) || null;
            this.defaultValue.address_2.street = (this.customer.address_2 && this.customer.address_2.street) || null;
            this.defaultValue.address_2.street2 = (this.customer.address_2 && this.customer.address_2.street2) || null;
            this.defaultValue.address_2.postal_code = (this.customer.address_2 && this.customer.address_2.postal_code) || null;
            this.defaultValue.address_2.city = (this.customer.address_2 && this.customer.address_2.city) || null;
            this.defaultValue.email_2 = this.customer.email_2 || null;
            if (this.customer.mobile_2) {
                const { countryCode, phoneNumber } = this.extractPhoneComponents(this.customer.mobile_2);
                this.defaultValue.mobile_2 = phoneNumber;
                this.defaultValue.mobile_2_code = countryCode;
            } else {
                this.defaultValue.mobile_2 = null;
                this.defaultValue.mobile_2_code = '+33';
            }
            this.defaultValue.workplace_2 = this.customer.workplace_2 || null;
            this.defaultValue.wedding_date = this.customer.wedding_date && moment(this.customer.wedding_date) || null;
            this.defaultValue.wedding_place = this.customer.wedding_place || null;
            this.defaultValue.wedding_master = this.customer.wedding_master || null;
            this.defaultValue.first_household_reference_income_taxe_2 = this.customer.first_household_reference_income_taxe_2 || null;
            this.defaultValue.second_household_reference_income_taxe_2 = this.customer.second_household_reference_income_taxe_2 || null;
            this.defaultValue.monthly_pay_2 = this.customer.monthly_pay_2 || null;
            this.defaultValue.job_status_2 = this.customer.job_status_2 || null;
            this.defaultValue.job_since_2 = this.customer.job_since_2 || null;
            this.defaultValue.real_costs_2 = this.customer.real_costs_2 || null;
            this.defaultValue.rent_collected_2 = this.customer.rent_collected_2 || null;
            this.defaultValue.dividends_before_deduction_2 = this.customer.dividends_before_deduction_2 || null;
            this.defaultValue.other_income_before_deduction_2 = this.customer.other_income_before_deduction_2 || null;
            this.defaultValue.income_taxe_2 = this.customer.income_taxe_2 || null;
            this.defaultValue.income_deduction_2 = this.customer.income_deduction_2 || null;
            this.defaultValue.income_deduction_reason_2 = this.customer.income_deduction_reason_2 || null;
            this.defaultValue.tax_reduction_2 = this.customer.tax_reduction_2 || null;
            this.defaultValue.tax_reduction_reason_2 = this.customer.tax_reduction_reason_2 || null;
            this.defaultValue.csg_crds_2 = this.customer.csg_crds_2 || null;
            this.defaultValue.tax_credit_2 = this.customer.tax_credit_2 || null;
            this.defaultValue.tax_before_reduction_2 = this.customer.tax_before_reduction_2 || null;
            this.defaultValue.real_estate_taxes_2 = this.customer.real_estate_taxes_2 || null;
            this.defaultValue.dom_deduction_2 = this.customer.dom_deduction_2 || null;
            this.defaultValue.study_coordinates = this.customer.study_coordinates || null;
            this.defaultValue.study_contact = this.customer.study_contact || null;
            this.defaultValue.study_mobile = this.customer.study_mobile || null;
            this.defaultValue.study_email = this.customer.study_email || null;
            this.defaultValue.study_address.street =
                (this.customer.study_address && this.customer.study_address.street) || null;
            this.defaultValue.study_address.street2 =
                (this.customer.study_address && this.customer.study_address.street2) || null;
            this.defaultValue.study_address.postal_code =
                (this.customer.study_address && this.customer.study_address.postal_code) || null;
            this.defaultValue.study_address.city =
                (this.customer.study_address && this.customer.study_address.city) || null;
            this.defaultValue.max_credit = this.customer.max_credit || null;
            this.defaultValue.max_credit_duration = this.customer.max_credit_duration || null;
            this.defaultValue.rate_excluding_insurance = this.customer.rate_excluding_insurance || null;
            this.defaultValue.tax_chosen = this.customer.tax_chosen || null;
            this.defaultValue.other_conditions = this.customer.other_conditions || null;
        } else {
            // if create (type === 'add') or no customer
            this.defaultValue.civility = null;
            this.defaultValue.first_firstname = null;
            this.defaultValue.first_lastname = null;
            this.defaultValue.second_firstname = null;
            this.defaultValue.second_lastname = null;
            this.defaultValue.company_name = null;
            this.defaultValue.email = null;
            this.defaultValue.birthdate = null;
            this.defaultValue.phone = null;
            this.defaultValue.mobile = null;
            this.defaultValue.address.street = null;
            this.defaultValue.address.street2 = null;
            this.defaultValue.address.postal_code = null;
            this.defaultValue.address.city = null;
            this.defaultValue.status = null;
        }
        this.loading = false;
    }

    async submit(form: any) {
        this.loading = true;
        const newCustomer: Customer = {
            civility: form.civility,
            family_situation: form.family_situation,
            first_firstname: form.first_firstname,
            first_lastname: form.first_lastname,
            second_firstname: form.second_firstname,
            second_lastname: form.second_lastname,
            company_name: form.company_name,
            email: form.email,
            birthdate: form.birthdate,
            phone: form.phone,
            workplace: form.workplace,
            income_taxe: form.income_taxe,
            second_household_reference_income_taxe: form.second_household_reference_income_taxe,
            first_household_reference_income_taxe: form.first_household_reference_income_taxe,
            share_of_taxe_home: form.share_of_taxe_home,
            people_in_tax_home: form.people_in_tax_home,
            childrens_in_tax_home: form.childrens_in_tax_home,
            monthly_pay: form.monthly_pay,
            mobile: this.formatPhoneNumber(form.mobile_code, form.mobile),
            address: {
                country: form.address.country,
                street: form.address.street,
                street2: form.address.street2,
                postal_code: form.address.postal_code,
                city: form.address.city,
            },
            status: form.status,
            notary_fees: form.notary_fees,
            tax_system: form.tax_system,
            geo_zone: form.geo_zone,
            acquisition_date: form.acquisition_date,
            surface: form.surface,
            rent: form.rent,
            personnal_apport: form.personnal_apport,
            credit_rate: form.credit_rate,
            credit_duration: form.credit_duration,
            lot_price: form.lot_price,

            job_status: form.job_status,
            job_since: form.job_since,
            real_costs: form.real_costs,
            rent_collected: form.rent_collected,
            dividends_before_deduction: form.dividends_before_deduction,
            other_income_before_deduction: form.other_income_before_deduction,
            tax_residence: form.tax_residence,
            tax_residence_c2: form.tax_residence_c2,
            tax_number: form.tax_number,
            tax_number_c2: form.tax_number_c2,
            taxes_c2: form.taxes_c2,
            tax_before_reduction: form.tax_before_reduction,
            csg_crds: form.csg_crds,
            real_estate_taxes: form.real_estate_taxes,
            dom_deduction: form.dom_deduction,
            income_deduction: form.income_deduction,
            income_deduction_reason: form.income_deduction_reason,
            tax_reduction: form.tax_reduction,
            tax_reduction_reason: form.tax_reduction_reason,
            tax_credit: form.tax_credit,
            investment_horizon: form.investment_horizon,
            income_goals: form.income_goals,
            capital_goals: form.capital_goals,
            retirement_goals: form.retirement_goals,

            civility_2: form.civility_2,
            date_of_birth_2: form.date_of_birth_2,
            address_2: form.address_2,
            email_2: form.email_2,
            mobile_2: form.mobile_2 ? this.formatPhoneNumber(form.mobile_2_code, form.mobile_2) : '',
            workplace_2: form.workplace_2, // Toujours facultatif
            wedding_date: form.wedding_date,
            wedding_place: form.wedding_place,
            wedding_master: form.wedding_master,
            first_household_reference_income_taxe_2: form.first_household_reference_income_taxe_2,
            second_household_reference_income_taxe_2: form.second_household_reference_income_taxe_2,
            monthly_pay_2: form.monthly_pay_2,
            job_status_2: form.job_status_2,
            job_since_2: form.job_since_2,
            real_costs_2: form.real_costs_2,
            rent_collected_2: form.rent_collected_2,
            dividends_before_deduction_2: form.dividends_before_deduction_2,
            other_income_before_deduction_2: form.other_income_before_deduction_2,
            income_taxe_2: form.income_taxe_2,
            income_deduction_2: form.income_deduction_2,
            income_deduction_reason_2: form.income_deduction_reason_2,
            tax_reduction_2: form.tax_reduction_2,
            tax_reduction_reason_2: form.tax_reduction_reason_2,
            csg_crds_2: form.csg_crds_2,
            tax_credit_2: form.tax_credit_2,
            tax_before_reduction_2: form.tax_before_reduction_2,
            real_estate_taxes_2: form.real_estate_taxes_2,
            dom_deduction_2: form.dom_deduction_2,
            study_coordinates: form.study_coordinates,
            study_contact: form.study_contact,
            study_mobile: form.study_mobile,
            study_email: form.study_email,
            study_address: form.study_address,
            max_credit: form.max_credit,
            max_credit_duration: form.max_credit_duration,
            rate_excluding_insurance: form.rate_excluding_insurance,
            tax_chosen: form.tax_chosen,
            other_conditions: form.other_conditions,
        };
        const $vs = (this as any).$vs;
        try {
            if (this.type === 'add') {
                const { data } = await postCustomerPrescriber(newCustomer);
                $vs.notify({
                    color: 'success',
                    position: 'top-right',
                    title: 'Création',
                    text: `Création du client réussie`,
                });
                if (data.id) {
                    router.push({
                        name: 'showProspect',
                        params: {
                            customerID: `${data.id}`,
                        },
                    });
                }
            } else {
                if (this.prospectID) {
                    await patchCustomerPrescriber(this.prospectID, newCustomer);
                    $vs.notify({
                        color: 'success',
                        position: 'top-right',
                        title: 'Modification',
                        text: `Modification du client réussie`,
                    });
                    router.push({
                        name: 'showProspect',
                        params: {
                            customerID: `${this.prospectID}`,
                        },
                    });
                }
            }
        } catch (error) {
            this.errors = error.response.data.errors.children;
            $vs.notify({
                color: 'danger',
                position: 'top-right',
                title: 'Erreur',
                text: 'Erreur lors de la soumission du formulaire',
            });
        } finally {
            this.loading = false;
        }
    }

    get customerTypesArr() {
        return Object.keys(customerTypes).map(key => ({
            text: (customerTypes as any)[key],
            value: key,
        }));
    }

    get customerCivilitiesArr() {
        return Object.keys(civilities).map(key => ({
            text: (civilities as any)[key],
            value: key,
        }));
    }

    get customerFamilyArr() {
        return Object.keys(families).map(key => ({
            text: (families as any)[key],
            value: key,
        }));
    }

    get customerStatus() {
        return Object.entries(customerStatus).map(([key, text]) => ({
            text,
            value: key,
        }));
    }

    tugudu(value: any) {
        if (value.civility === 'Société') {
            value.first_firstname = null;
            value.second_firstname = null;
            value.first_lastname = null;
            value.second_lastname = null;
        }
        if (value.civility === 'M.' || value.civility === 'Mme.') {
            value.company_name = null;
            value.second_firstname = null;
            value.second_lastname = null;
        }
        if (
            value.civility === 'M. et M.' ||
            value.civility === 'Mme. et Mme' ||
            value.civility === 'M. et Mme.'
        ) {
            value.company_name = null;
        }
        this.defaultValue = value;
    }
}
